import avatar1 from '@images/avatars/avatar-1.png'
import avatar2 from '@images/avatars/avatar-2.png'
import avatar3 from '/images/avatars/avatar-abby.webp'

export const db = {
  users: [
    {
      id: 1,
      fullName: 'Abby Carter',
      company: 'Salubris',
      role: 'admin',
      username: 'abbycarter',
      country: 'Perth, WA',
      contact: '(479) 232-9151',
      email: 'abby@carterco.co',
      currentPlan: 'enterprise',
      status: 'Active',
      avatar: avatar3,
    },
    {
      id: 2,
      fullName: 'Cy L',
      company: 'Carter & Co',
      role: 'author',
      username: 'ccl',
      country: 'PH',
      contact: '(472) 607-9137',
      email: 'cy@carterco.co',
      currentPlan: 'editor',
      status: 'Active',
      avatar: avatar2,
    },
  ],
}
